import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {of} from 'rxjs';
import {switchMap, map, catchError} from 'rxjs/operators';
import { Store } from '@ngrx/store';

import {AppState} from "../app.state";

import {MsalBroadcastService} from "@azure/msal-angular";
import {executeGlobalSearch, executeGlobalSearchFailure, executeGlobalSearchSuccess} from "./global-search.action";
import {GlobalSearchService} from "../../data-access/global-search.service";

@Injectable()
export class GlobalSearchEffects {
  executeGlobalSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(executeGlobalSearch),
      switchMap((action) =>
        this.globalSearchService.search(action.searchTerm)
          .pipe(
            map((globalSearchResults) => executeGlobalSearchSuccess({globalSearchResults})),
            catchError((error) => of(executeGlobalSearchFailure({ error })))
          )
      )
    )
  );


  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private broadcastService: MsalBroadcastService,
    private globalSearchService: GlobalSearchService,
  ) {}
}
